import {FC, ReactNode} from 'react'
import {Col, Row} from 'react-bootstrap'

interface PageContentProps {
  children: ReactNode;
  maxWidth?: number;
  centered?: boolean;
  className?: string;
}

const PageContent: FC<PageContentProps> = ({
  children,
  maxWidth,
  centered = false,
  className = ''
}) => {
  if (centered) {
    return (
      <Row className={`justify-content-center ${className}`}>
        <Col xs={12} lg={maxWidth || 8} className="mx-auto">
          {children}
        </Col>
      </Row>
    )
  }

  return (
    <Row className={className}>
      {maxWidth ? (
        <Col xs={12} lg={maxWidth}>
          {children}
        </Col>
      ) : (
        <Col>
          {children}
        </Col>
      )}
    </Row>
  )
}

export default PageContent
